import classNames from 'classnames';
import React from 'react';

import { Category } from '@/types/Category';

import { B2BCategory } from '../b2b-category/b2b-category';
import styles from './b2b-categories-block.module.scss';

interface Props {
    categories: Category[];
}

const B2BCategoriesBlock: React.FC<Props> = (props: Props) => {
    const { categories } = props;
    return (
        <div className={styles.articleCategoriesContainer}>
            <p className={classNames(styles.categoriesHeading)}>Categories</p>
            <B2BCategory categories={categories} />
        </div>
    );
};

export default B2BCategoriesBlock;
